/*
  Choice

    This component is used by MultipleChoiceModalDialog to display an single choice
    in the list displayed by the dialog.  It has no state.

  Properties:

    title: The name of the choice.
    description: A detailed description of the choice. May be a blank string.
    onClick: A function to call when the choice is clicked. MultipleChoiceModalDialog uses this to update
      the style when a click occurs and also to know which choice is selected.
    variant: The variant to use for the card.  Should be either "selected" or "outlined".

  State:

    None.

  */
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import useAMRevamp from '~/hooks/useAMRevamp';

type ChoicePropOptions = {
  title: string;
  description: string;
  variant: 'elevation' | 'outlined' | 'selected';
  onClick: VoidFunction;
};

const Choice = ({
  title,
  description,
  onClick,
  variant,
  ...props
}: ChoicePropOptions) => {
  const { isAMRevamp } = useAMRevamp();
  return (
    <Card
      variant={variant}
      {...props}
      onClick={onClick}
      {...(isAMRevamp && { sx: { p: 0 } })}
    >
      <CardActionArea>
        <CardContent sx={{ p: 2 }}>
          <Stack direction="column" spacing={1}>
            <Typography variant="h3">{title}</Typography>
            <Typography variant="body2">{description}</Typography>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default Choice;
